import { api } from '@/lib/api'

export function logout() {
  return api.post<void>('/v1/logout')
}
